import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

import { CacheKeys } from '../lib/cache'
import { toCamelCase } from '../lib/typeHelper'
import { SalesLeadStatus } from './salesLead'

export enum RecommendationAction {
  CALL = 'CALL',
  EMAIL = 'EMAIL',
  SEQUENCE = 'SEQUENCE',
  STATUS_CHANGE = 'STATUS_CHANGE',
}

export enum RecommendationPriority {
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW',
}

export interface Recommendation {
  action: RecommendationAction
  priority: RecommendationPriority
  reasoning: string
  suggestedEmailSubject: string
  suggestedEmailBody: string
  generatedBy: 'agent' | 'fallback'
  generatedAt: string
  metadata: {
    reason: 'stalled' | 'expiring' | 'both'
    daysSinceActivity: number | null
    daysToExpiry: number | null
  }
}

export interface WorkQueueItem {
  id: string
  legalName: string
  dbaName: string
  status: SalesLeadStatus
  daysUntilExpiration: number | null
  assignedRep: string | null
  availableTransitions: SalesLeadStatus[]
  recommendation: Recommendation
}

export function fetchWorkQueue(): Promise<WorkQueueItem[]> {
  return axios
    .get('/api/v1/insure/internal/sales-leads/work-queue/')
    .then((response) => toCamelCase(response.data) as WorkQueueItem[])
}

export function useWorkQueue() {
  const { data, isLoading } = useQuery({
    queryKey: [CacheKeys.WORK_QUEUE],
    queryFn: fetchWorkQueue,
  })
  return { items: data ?? [], isLoading }
}
